import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import { Alert } from "react-bootstrap";
import { getEventsInRange } from "../../api/requests";
import Events from "../Events/Events";

const sameDay = (a, b) => a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

function EventDetails({ events, date }) {
    const filtered = events.filter((event) => sameDay(new Date(event.start_datetime), date));
    if (filtered.length === 0) return null;
    return (
        <div>
            {filtered.map((event) => (
                <div key={event.id}>
                    <h3>{event.event_name}</h3>
                    <p className="plain-text">{event.event_description}</p>
                </div>
            ))}
        </div>
    );
}

function Calendartsc() {
    const [value, setValue] = useState(new Date());
    const [activeStartDate, setActiveStartDate] = useState(() => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 1);
    });
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const year = activeStartDate.getFullYear();
    const month = activeStartDate.getMonth();

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError("");
        setEvents([]);
        const start = new Date(year, month, 1).toISOString();
        const end = new Date(year, month + 1, 1).toISOString();
        getEventsInRange(start, end).then((result) => {
            if (!cancelled) setEvents(result);
        }).catch(() => {
            if (!cancelled) setError("Events konnten nicht geladen werden.");
        }).finally(() => {
            if (!cancelled) setLoading(false);
        });
        return () => { cancelled = true; };
    }, [year, month]);

    function tileClassName({ date, view }) {
        if (view === 'month' && events.some((event) => sameDay(new Date(event.start_datetime), date))) {
            return 'event-day';
        }
    }

    return (
        <div className="calendar">
            <Calendar
                locale="de-DE"
                value={value}
                onChange={setValue}
                activeStartDate={activeStartDate}
                onActiveStartDateChange={({ activeStartDate: date }) => setActiveStartDate(date)}
                tileClassName={tileClassName}
                showNeighboringMonth={false}
                prevAriaLabel="Vorheriger Monat"
                nextAriaLabel="Nächster Monat"
                prev2Label={null}
                next2Label={null}
            />
            {loading && <p role="status">Events werden geladen …</p>}
            {error && <Alert variant="danger">{error}</Alert>}
            {!loading && !error && <>
                <EventDetails events={events} date={value} />
                <Events events={events} />
            </>}
        </div>
    );
}

export default Calendartsc;
